import { FrozenKey } from '../enums';

const MapTranslationKey: Record<FrozenKey, string> = {
  freezeDate: 'buildingDetail.freezeDate',
  unfreezeDate: 'buildingDetail.unfreezeDate',
  freezeReason: 'buildingDetail.freezeReason',
  comments: 'buildingDetail.comments',
  pboReference: 'buildingDetail.pboReference',
  freezePbo: 'buildingDetail.freezePbo',
  dateUnfreezePbo: 'buildingDetail.dateUnfreezePbo',
  freezePboReason: 'buildingDetail.freezePboReason'
};

export default MapTranslationKey;
